<template>
  <v-container
    class="py-0"
  >
    <v-card
      min-height="500"
      class="mb-3"
    >
      <v-tabs
        v-model="tab"
        background-color="blue accent-4"
        centered
        dark
        icons-and-text
        show-arrows
      >
        <v-tabs-slider />
        <v-tab
          v-for="(t, i) in (tabs)"
          v-show="i!=2 || plane.rentable"
          :key="i"
        >
          {{ t.text }}
          <v-icon v-text="t.icon" />
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
          key="tab-item-1"
          class="pa-4 text-body-2 font-weight-light"
        >
          <v-row>
            <v-col
              cols="12"
              md="3"
            >
              <data-selector
                v-model="plane.plane_type_id"
                autofocus
                field-name="plane_type"
                source-type="planeTypes"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="plane.reg_num"
                field-name="reg_num"
                rules="required|min:4|max:10"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <airport-selector
                v-model="plane.base_airport_id"
                field-name="base_airport"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="plane.plane_class"
                field-name="plane_class"
                rules=""
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="plane.manufacturer"
                field-name="manufacturer"
                rules=""
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="plane.construction_date"
                field-name="construction_date"
                :rules="'numeric|between:1900,'+(new Date().getFullYear())"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="plane.serial_no"
                field-name="serial_no"
                rules=""
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="plane.model"
                field-name="model"
                rules="required|min:4|max:20"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="plane.seats"
                field-name="seats"
                rules="required|numeric|between:1,10"
                type="number"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="plane.tail_number"
                field-name="tail_number"
                rules=""
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="plane.ogn_id"
                field-name="ogn_id"
                rules="alpha_num|min:9|max:9"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <data-selector
                v-model="plane.category_id"
                field-name="plane_category"
                source-type="planeCategories"
                translate
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <validated-text-field
                v-model="plane.owner_names"
                field-name="owner_names"
                rules="required"
                type="text"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="2"
              sm="6"
            >
              <v-checkbox
                v-model="plane.tow_plane"
                :label="$t('fields.tow_plane')"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
              sm="6"
            >
              <v-checkbox
                v-model="plane.multi_engine"
                :label="$t('fields.multi_engine')"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
              sm="6"
            >
              <v-checkbox
                v-model="plane.multi_pilot"
                :label="$t('fields.multi_pilot')"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
              sm="6"
            >
              <v-checkbox
                v-model="plane.functional"
                :label="$t('fields.functional')"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
              sm="6"
            >
              <v-checkbox
                v-model="plane.maintenance"
                :label="$t('fields.under_maintenance')"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
              sm="6"
            >
              <v-checkbox
                v-model="plane.external_edit_on"
                :label="$t('fields.external_edit_on')"
              />
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item
          key="tab-item-2"
          class="pa-4 text-body-2 font-weight-light"
        >
          <v-row justify="center">
            <v-col
              cols="12"
              md="3"
            >
              <v-checkbox
                v-model="plane.rentable"
                :label="$t('fields.rentable')"
                @click="plane.rentable ? tab=2 : tab=tab"
              />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              cols="12"
              md="3"
            >
              <v-checkbox
                v-model="plane.rent_multiple_day_allowed"
                :label="$t('fields.rent_multiple_days_allowed')"
                md="4"
              />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              cols="12"
              md="3"
            >
              <v-checkbox
                v-model="plane.rent_req_instructor"
                :label="$t('fields.rent_req_instructor')"
                md="4"
              />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              cols="12"
              md="3"
            >
              <v-checkbox
                v-model="plane.private"
                :label="$t('fields.private_plane')"
              />
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item
          key="tab-item-3"
          class="pa-4 text-body-2 font-weight-light"
        >
          <v-row>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="plane.rent_type_id"
                field-name="rent_type"
                autofocus
                rules=""
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="plane.rent_price_flight"
                field-name="rent_price_flight"
                rules="required|numeric"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="plane.rent_price_motor"
                field-name="rent_price_motor"
                rules="required|numeric"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="plane.rent_price_training"
                field-name="rent_price_training"
                rules="numeric"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="plane.rent_price_landing"
                field-name="rent_price_landing"
                rules="numeric"
                type="text"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <v-checkbox
                v-model="plane.rent_flat_rate"
                :label="$t('fields.rent_flat_rate')"
              />
            </v-col>
          </v-row>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t('fields.custom_prices') }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container class="py-0 px-5">
                  <v-btn
                    block
                    class="mb-6"
                    @click="addBlankCustomPrice"
                  >
                    {{ $t('add_custom_price') }}
                  </v-btn>
                  <v-row
                    v-for="(custom_price,i) in plane.custom_prices"
                    :key="i"
                  >
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <data-selector
                        v-model="custom_price.membership_id"
                        field-name="membership_type"
                        source-type="memberships"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <validated-text-field
                        v-model="custom_price.rent_price_flight"
                        field-name="rent_price_flight"
                        rules="required|numeric"
                        type="text"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <validated-text-field
                        v-model="custom_price.rent_price_motor"
                        field-name="rent_price_motor"
                        rules="required|numeric"
                        type="text"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <validated-text-field
                        v-model="custom_price.rent_price_training"
                        field-name="rent_price_training"
                        rules="numeric"
                        type="text"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <validated-text-field
                        v-model="custom_price.rent_price_landing"
                        field-name="rent_price_landing"
                        rules="numeric"
                        type="text"
                      />
                    </v-col>
                    <v-col
                      cols="1"
                    >
                      <v-btn
                        icon
                        color="delete"
                        class="mt-5"
                        @click="removeCustomPrice(custom_price)"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t('fields.free_users') }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container class="py-0 px-5">
                  <v-btn
                    block
                    class="mb-6"
                    @click="addBlankFreeUser"
                  >
                    {{ $t('add_user') }}
                  </v-btn>
                  <v-row
                    v-for="(user,i) in plane.free_users"
                    :key="i"
                  >
                    <v-col cols="6">
                      <data-selector
                        v-model="user.id"
                        autofocus
                        field-name="user"
                        source-type="users"
                      />
                    </v-col>
                    <v-col
                      cols="1"
                    >
                      <v-btn
                        icon
                        color="delete"
                        class="mt-5"
                        @click="removeFreeUser(user)"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-tab-item>

        <v-tab-item
          key="tab-item-4"
          class="pa-4 text-body-2 font-weight-light"
        >
          <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <validated-text-field
                v-model="plane.prev_flighttime"
                field-name="prev_flighttime"
                autofocus
                rules="required|double"
                type="number"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <validated-text-field
                v-model="plane.prev_landing"
                field-name="prev_landing"
                rules="required|numeric"
                type="number"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <validated-text-field
                v-model="plane.prev_counter"
                field-name="prev_counter"
                rules="required|double"
                type="number"
              />
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item
          key="tab-item-5"
          class="pa-4 text-body-2 font-weight-light"
        >
          <v-col
            cols="12"
            md="12"
          >
            <app-card class="mt-4 text-center" justify="center">
              <v-card-title class="justify-center">
                <h6 class="text-h6 mb-2 text--secondary">
                  {{ $t('fields.photo') }}
                </h6>
              </v-card-title>
              <v-card-text class="d-flex flex-column justify-space-between align-center">
                <v-img
                  v-if="plane.avatar"
                  max-width="700px"
                  :lazy-src="'data:image/jpeg;base64,' + plane.avatar.thumbnail"
                  :src="dataUrl"
                />
              </v-card-text>
              <v-card-actions class="justify-center">
                <upload-files
                  filter="avatar"
                  source-type="avatar"
                  class="mt-2"
                  @success="uploaded"
                />
              </v-card-actions>
            </app-card>
          </v-col>
        </v-tab-item>
        <v-tab-item
          key="tab-item-6"
          class="pa-4 text-body-2 font-weight-light"
        >
          <v-col
            cols="12"
            md="12"
          >
            <v-textarea
              v-model="plane.comment"
              clearable
              autofocus
              outlined
              clear-icon="mdi-close-circle"
              counter
            />
          </v-col>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    name: 'EditPlane',
    props: {
      plane: Object,
    },
    data: function () {
      return {
        tab: null,
        tabs: [
          {
            text: this.$t('basic_informations'),
            icon: '$info',
          },
          {
            text: this.$t('renting_informations'),
            icon: 'mdi-tools',
          },
          {
            text: this.$t('prices'),
            icon: 'mdi-cash-multiple',
          },
          {
            text: this.$t('other_informations'),
            icon: 'mdi-history',
          },
          {
            text: this.$t('plane_avatar'),
            icon: 'mdi-image',
          },
          {
            text: this.$t('comments'),
            icon: 'mdi-note-text',
          },
        ],
      }
    },
    computed: {
      dataUrl () {
        return process.env.VUE_APP_API_URL + '/api/storage/avatar/' + this.plane.avatar_id
      },
    },
    methods: {
      uploaded (response) {
        this.plane.avatar_id = response.id
        this.plane.avatar = response
        console.log(response.id)
      },
      removeCustomPrice (item) {
        // console.log(item)
        // console.log('remove' + item.id)
        this.plane.custom_prices.splice(this.plane.custom_prices.indexOf(item), 1)
      },
      addBlankCustomPrice () {
        this.plane.custom_prices.push({
          membership_id: null,
          rent_price_flight: 0,
          rent_price_motor: 0,
          rent_price_landing: 0,
          rent_price_training: 0,
        })
      },
      removeFreeUser (item) {
        // console.log(item)
        // console.log('remove' + item.id)
        this.plane.free_users.splice(this.plane.free_users.indexOf(item), 1)
      },
      addBlankFreeUser () {
        this.plane.free_users.push({
          id: null,
        })
      },
    },
  }
</script>
